import {Axios} from '@asocial/fe-utils'
import {AxiosResponse} from 'axios'
import {ErrorResponsesType} from 'shared/types'
import {ChatRequest} from '../activity'
import {messageTypes} from './config'
import {DialogItemType, GetDialogsResponse, MessageType} from './model'
import {SendMessageRequestType} from './types'

export const SendMessageRequest = (idUser: string, data: SendMessageRequestType, type: messageTypes): Promise<AxiosResponse<MessageType, ErrorResponsesType>> =>
  Axios.post(`chat/dialogs/${idUser}/${type}`, data)

export const PurchaseMessageRequest = (idMessage: string): Promise<AxiosResponse<MessageType>> =>
  Axios.post(`/chat/purchase/${idMessage}`)

export const GetChatDialog = (idUser: string): Promise<AxiosResponse<DialogItemType>> =>
  Axios.get(`chat/dialogs/${idUser}`)

export const GetDialogsRequest = (): Promise<GetDialogsResponse> =>
  Axios.get(`chat/dialogs`)

export const ReadMessage = (idUser: string, idMessage: string): Promise<AxiosResponse<{unreadCount: number}>> =>
  Axios.patch(`/chat/dialogs/${idUser}/read`, {idLastMessage: idMessage})

export const GetChatRequest = (idUser: string): Promise<AxiosResponse<ChatRequest>> =>
  Axios.get(`/activity/chat-requests/${idUser}`)